import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

// Needed for loading decision in index.html
(window as any).LEAPA_ENABLED = environment.LEAPA_ENABLED;
(window as any).REMITA_ENABLED = environment.REMITA_ENABLED;
(window as any).REMITA_SCRIPT_URL = environment.REMITA_SCRIPT_URL;

if (environment.PRODUCTION) {
  enableProdMode();
}

// Currently missing translation warnings cannot be turned off https://github.com/angular/angular/issues/44617
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => console.log('Bootstrap success'))
  .catch((err) => console.error(err));
